type WaveMarkProps = {
  className?: string;
};

export default function WaveMark({ className = "" }: WaveMarkProps) {
  return (
    <span className={`flex flex-col justify-between ${className}`} aria-hidden="true">
      <span className="block h-[2px] w-full -rotate-2 rounded-full bg-primary-500" />
      <span className="block h-[2px] w-[86%] rotate-2 rounded-full bg-accent-500" />
      <span className="block h-[2px] w-[94%] -rotate-1 rounded-full bg-secondary-500" />
      <span className="block h-[2px] w-[72%] rotate-1 rounded-full bg-primary-500" />
    </span>
  );
}